import React, {useEffect, useState} from "react";
import ArgosDialog from "../../../../components/Dialogs/ArgosDialog";
import ArgosFlexbox from "../../../../components/Containers/ArgosFlexbox";
import ArgosTextField from "../../../../components/Form/TextField/ArgosTextField";
import ArgosButton, {ArgosLoadingButton} from "../../../../components/Buttons/ArgosButton";

interface IProps {
  commonEditSensorRootFieldsDialogData: any
  commonEditSensorRootFields: (data: any) => void
  setCommonEditSensorRootFieldsDialogData: React.Dispatch<React.SetStateAction<any>>
  editSensorDialogTitle: string
}

const EditSensorDialog = (props: IProps) => {
  const {
    commonEditSensorRootFieldsDialogData, setCommonEditSensorRootFieldsDialogData,
    commonEditSensorRootFields, editSensorDialogTitle
  } = props

  const [commonEditSensorRootFieldsState, setCommonEditSensorRootFieldsState] = useState<any>({})

  useEffect(() => {
    if (commonEditSensorRootFieldsDialogData) {
      setCommonEditSensorRootFieldsState({
        comments: commonEditSensorRootFieldsDialogData.comments || ''
      })
    }
  }, [commonEditSensorRootFieldsDialogData]);

  return (
    <ArgosDialog
      minWidth={'0px'} maxWidth={'30vw'} height={'fit-content'}
      open={commonEditSensorRootFieldsDialogData}
      onClose={() => {
        setCommonEditSensorRootFieldsDialogData(null)
      }}
      headerTitle={editSensorDialogTitle}
      headerTitleAlign={'left'}
    >
      <>
        {!commonEditSensorRootFieldsDialogData ? <></> :
          <ArgosFlexbox vertical>
            <div>
              {/* Add fields to edit here */}
              <ArgosFlexbox vertical>
                <ArgosTextField
                  rows={4}
                  multiline label={"Comments"}
                  value={commonEditSensorRootFieldsState?.comments || ''}
                  onChange={(e) => {
                    setCommonEditSensorRootFieldsState({
                      ...commonEditSensorRootFieldsState,
                      comments: e.target.value
                    })
                  }}
                />
              </ArgosFlexbox>
            </div>
            <ArgosFlexbox alignItems={'center'} justifyContent={'center'}>
              <ArgosButton
                onClick={() => {
                  setCommonEditSensorRootFieldsDialogData(null)
                }}
              >
                CANCEL
              </ArgosButton>
              {
                <ArgosLoadingButton
                  onClick={() => {
                    setCommonEditSensorRootFieldsDialogData(null)
                    const payload = {
                      fieldsToUpdate: commonEditSensorRootFieldsState,
                      sensorId: commonEditSensorRootFieldsDialogData.id
                    }
                    commonEditSensorRootFields(payload)
                  }}
                >
                  SAVE
                </ArgosLoadingButton>
              }
            </ArgosFlexbox>
          </ArgosFlexbox>
        }
      </>
    </ArgosDialog>
  )
}

export default EditSensorDialog